@import '../../../globals/main.scss';

//making pn wrapping link clickable over card image
.block.teasercardblock {
  a[data-block-clickable-link='true'] {
    z-index: 1;
  }
}

//mobile first
pn-teaser-card {
  width: 100%;
  height: 100%;
  display: flex;

  .pn-teaser-card__container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    border-radius: 2.4rem;
    width: 100%;
  }

  .pn-teaser-card__container__image__container {
    width: 100%;
    position: relative;

    & > [slot='illustration'] {
      clip-path: ellipse(100% 90% at 50% 0%);
      height: 100%;
      overflow: hidden;
      border-top-left-radius: 2.4rem;
      border-top-right-radius: 2.4rem;

      & > picture > img {
        width: 100%;
        height: auto;
        transition: 0.4s ease-in-out;
        transform: scale(1);
        aspect-ratio: 16/9;
        object-fit: cover;
        object-position: 50% 0;
      }
    }
  }

  .pn-teaser-card__container__content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1 1 100%;
    gap: 3.2rem;
    padding: 2.4rem 2.4rem;
    padding-top: 0;
  }

  .pn-teaser-card__container__content__text__container__heading {
    font-weight: 700;
    font-size: 2.4rem;
    line-height: 2.64rem;
    margin-bottom: 0;
  }

  .pn-teaser-card__container__content__text__container__preamble {
    padding-top: 1.6rem;
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 2.24rem;
    margin-bottom: 0;
  }

  .pn-teaser-card__container__content__text__container__label {
    display: block;
    margin-bottom: 1.6rem;
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 140%;
  }

  .pn-teaser-card__container__content__cta {
    & > pn-button {
      align-self: flex-end;
      width: 100%;

      & a:hover {
        text-decoration: none;
      }

      & > button,
      & > a {
        & > .pn-button-bg {
          transition: 0.4s ease-in-out;
        }
      }

      @media screen and (min-width: $min-width-md) {
        width: fit-content;
      }
    }

    .secondary-link--animated {
      font-weight: 500;
      font-size: 1.6rem;
      text-decoration: none;
      color: $blue700;

      pn-icon svg {
        transition: 0.3s ease-in-out;
        position: relative;
        left: -0.3rem;

        path {
          fill: $blue700;
        }
      }

      &[target='_blank']:not(.pn-button):after {
        display: none;
      }
    }
  }
}

//colors
pn-teaser-card[data-card-color='coral'] {
  & > .pn-teaser-card__container {
    background-color: $coral50;
  }
}

pn-teaser-card[data-card-color='green'] {
  & > .pn-teaser-card__container {
    background-color: $green50;
  }
}

pn-teaser-card[data-card-color='blue'] {
  & > .pn-teaser-card__container {
    background-color: $blue25;
  }
}

pn-teaser-card[data-card-color='blue50'] {
  & > .pn-teaser-card__container {
    background-color: $blue50;
  }
}

pn-teaser-card[data-card-color='blue400'] {
  & > .pn-teaser-card__container {
    background-color: $blue400;

    .pn-teaser-card__container__content__text__container__label,
    .pn-teaser-card__container__content__text__container__heading,
    .pn-teaser-card__container__content__text__container__preamble,
    .pn-teaser-card__container__content__cta .secondary-link--animated {
      color: $white;
    }

    .secondary-link--animated {
      & > pn-icon > svg > path {
        fill: $white;
      }
    }
  }
}

pn-teaser-card[data-card-color='blue900'] {
  & > .pn-teaser-card__container {
    background-color: $blue900;
    .pn-teaser-card__container__content__text__container__heading {
      color: $blue200;
    }

    .pn-teaser-card__container__content__text__container__label,
    .pn-teaser-card__container__content__text__container__preamble,
    .pn-teaser-card__container__content__cta .secondary-link--animated {
      color: $white;
    }

    .secondary-link--animated {
      & > pn-icon > svg > path {
        fill: $white;
      }
    }
  }
}

pn-teaser-card[data-card-color='white'] {
  & > .pn-teaser-card__container {
    background-color: $white;
  }
}

//color override when in a listblock
.teasercardlistblock {
  .teasercardblock.has-bg {
    background-color: transparent;
    background: transparent;
  }
}

// variants

.onequarterwidth:not(.familywrapperblock) {
  .pn-teaser-card__container__content__text__container__label {
    @media screen and (min-width: $min-width-xl) {
      margin-bottom: 0.8rem;
    }
  }
}

.onethirdwidth:not(.familywrapperblock),
.onequarterwidth:not(.familywrapperblock) {
  & pn-teaser-card {
    .pn-teaser-card__container__image__container--no-image {
      padding-top: 2.4rem;
    }
  }

  .pn-teaser-card__container__content__cta {
    .secondary-link--animated {
      font-weight: 400;
    }
  }
}

.halfwidth:not(.familywrapperblock) {
  & pn-teaser-card {
    .pn-teaser-card__container__content__cta {
      .secondary-link--animated {
        font-weight: 400;
      }
    }

    .pn-teaser-card__container__image__container--no-image {
      padding-top: 2.4rem;
    }

    @media screen and (min-width: $min-width-lg) {
      .pn-teaser-card__container__content__cta {
        .secondary-link--animated {
          font-weight: 500;
        }
      }
    }

    @media screen and (min-width: $min-width-xl) {
      .pn-teaser-card__container__image__container--no-image {
        padding-top: 4rem;
      }

      .pn-teaser-card__container__content {
        padding: 0 4rem 4rem;
      }

      .pn-teaser-card__container__content__text__container__heading {
        font-weight: 700;
        font-size: 3.2rem;
        line-height: 3.52rem;
      }

      .pn-teaser-card__container__content__text__container__preamble {
        font-weight: 400;
        font-size: 2rem;
        line-height: 2.8rem;
      }
    }

    @media screen and (min-width: $min-width-xxl) {
      .pn-teaser-card__container__image__container--no-image {
        padding-top: 5.6rem;
      }

      .pn-teaser-card__container__content {
        padding: 0 5.6rem 5.6rem;
      }
    }
  }
}

.fullwidth:not(.familywrapperblock) {
  & pn-teaser-card {
    .pn-teaser-card__container__content__cta {
      .secondary-link--animated {
        font-weight: 400;
      }
    }

    .pn-teaser-card__container__image__container--no-image {
      width: auto;
      padding-top: 2.4rem;
    }

    @media screen and (min-width: $min-width-md) {
      min-height: 35rem;

      .pn-teaser-card__container__content__cta {
        .secondary-link--animated {
          font-weight: 500;
        }
      }

      .pn-teaser-card__container {
        flex-direction: row;
      }

      .pn-teaser-card__container__content {
        align-self: center;
        gap: 2.4rem;
        padding: 3.2rem 3.2rem 3.2rem 2.4rem;
      }

      .pn-teaser-card__container__image__container {
        & > [slot='illustration'] {
          border-top-left-radius: 2.4rem;
          border-bottom-left-radius: 2.4rem;
          clip-path: ellipse(100% 100% at 0% 50%);

          & > picture > img {
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }

    @media screen and (min-width: $min-width-xl) {
      min-height: 52rem;

      .pn-teaser-card__container__content {
        padding: 4rem 4rem 4rem 3.2rem;
      }

      .pn-teaser-card__container__content__text__container__heading {
        font-weight: 700;
        font-size: 4.8rem;
        line-height: 5.28rem;
      }

      .pn-teaser-card__container__content__text__container__preamble {
        font-size: 2rem;
        line-height: 2.8rem;
      }
    }
  }

  pn-teaser-card[data-card-alignment='right'] {
    @media screen and (min-width: $min-width-md) {
      .pn-teaser-card__container {
        flex-direction: row-reverse;
      }

      .pn-teaser-card__container__content {
        padding: 3.2rem 2.4rem 3.2rem 3.2rem;
      }

      .pn-teaser-card__container__image__container {
        & > [slot='illustration'] {
          border-bottom-right-radius: 2.4rem;
          clip-path: ellipse(100% 100% at 100% 50%);
        }
      }
    }

    @media screen and (min-width: $min-width-xl) {
      .pn-teaser-card__container__content {
        padding: 4rem 3.2rem 4rem 4rem;
      }
    }
  }
}

//effect class
pn-teaser-card.teaser-card--hover-effect {
  &:hover {
    cursor: pointer;
    .pn-teaser-card__container__image__container {
      & [slot='illustration'] {
        & picture > img {
          transform: scale(1.02);
          filter: brightness(0.85);
        }
      }
    }

    .secondary-link--animated {
      text-decoration: underline;

      pn-icon svg {
        left: 0;
      }
    }

    pn-button {
      button,
      a {
        .pn-button-bg {
          background-color: $blue900;
        }
      }
    }

    &[data-card-color='blue900'] {
      pn-button {
        button,
        a {
          .pn-button-bg {
            background-color: $blue400;
          }
        }
      }
    }
  }
}
